module.exports = __webpack_public_path__ + "static/media/icon-volume_on.82bd0f33.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-volume_on.svg
// module id = ./src/assets/images/icon-volume_on.svg
// module chunks = 0